<template>
  <div id="compreSportsMeet_delegationDetail_players" v-show="currThemeObj">
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <div class="match_label_fixed" v-show="curMatchLabelFixedIcon">
          <div class="match_label">
            <span class="label_textArea">
              <span class="labelIcon">
                <img
                  :src="`/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${currBigSports.icon}.png`"
                />
              </span>
              <span
                :class="[
                  currBigSports.label && currBigSports.label.length === 2
                    ? 'letterSpa'
                    : '',
                ]"
                v-text="currBigSports.label"
              ></span>
            </span>
            <span class="label_rightArea">
              <span
                class="rightArea_name"
                v-text="currBigSports.rightText"
              ></span>
              <span
                class="rightArea_value"
                v-text="currBigSports.rigthNum"
              ></span>
            </span>
          </div>
        </div>
        <div :class="scrollDomClassName">
          <playerList_groupItem
            v-for="item in matchList"
            :key="item.icon"
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :data="item"
            :pbPx="matchItemPbpx"
            :isShowLabelIcon="true"
            :mode="'mode_other'"
            :detailPathName="'CSMeetPlayerDetailIndex'"
          ></playerList_groupItem>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <!-- <p class="noDataClass" v-show="noData">暂无数据</p> -->
        <NOT_DATA :className="'relativePtb60'" v-if="noData" />
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import { https_delegationDetail_players } from '@api/platfrom_compreSportsMeet_api'
import NOT_DATA from '@components/base/NO_DATA.vue'
import BackTop from '@components/base/backTop.vue'
import playerList_groupItem from '@components/platfromBase/compreSportsMeet/playerList_groupItem.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_delegationDetail_players',
  components: {
    playerList_groupItem,
    NOT_DATA,
    BackTop,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      isScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      matchTotal: 0,
      showBackTop: false,
    }
  },
  beforeCreate() {},
  created() {
    this.query = this.$route.query
    this.initPbPx()
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    currBigSports() {
      const curMatchLabelFixedIcon = this.curMatchLabelFixedIcon
      let obj = {
        label: '',
        icon: curMatchLabelFixedIcon,
        rightText: '',
        rigthNum: '',
      }
      if (this.matchList && this.matchList.length > 0) {
        this.matchList.forEach((group) => {
          if (curMatchLabelFixedIcon === group.icon) {
            obj = {
              label: group.label,
              icon: curMatchLabelFixedIcon,
              rightText: '运动员：',
              rigthNum: group.rigthNum,
            }
          }
        })
      }
      return obj
    },
    noMore() {
      // return this.matchTotal !== 0 && this.isScrollBottom
      return this.matchTotal !== 0
    },
    noData() {
      return this.matchList && this.matchList.length == 0
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        const scrollTop = this.scrollAreaDom.scrollTop
        const scrollHeight = this.scrollAreaDom.scrollHeight
        const parentHeightPx = this.scrollAreaDom.offsetHeight
        let direction = this.DIRECTION_ENUM.DOWN
        if (this.beforeScrollTop > scrollTop) {
          direction = this.DIRECTION_ENUM.UP
        }
        // 通过滚动方向判断是触底还是触顶
        console.debug(
          'direction:',
          direction,
          scrollTop,
          parentHeightPx,
          scrollHeight,
          this.isScrollBottom
        )

        if (scrollTop > 300) {
          this.showBackTop = true
        } else {
          this.showBackTop = false
        }

        this.changeMatchLabelFixed(scrollTop, direction)

        if (direction == this.DIRECTION_ENUM.DOWN) {
          // 滚动触底
          if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
            console.debug('滚动触底')
            this.isScrollBottom = true
          }
        } else {
          // 滚动到顶部
          this.isScrollBottom = false
          if (scrollTop <= this.threshold) {
            console.debug('滚动到顶部')
          }
        }

        this.beforeScrollTop = this.scrollAreaDom.scrollTop
      })
    },
    changeMatchLabelFixed(valPx, direction) {
      let scrollMatchItemHeightArr = this.scrollMatchItemHeightArr || []
      let curMatchLabelFixedIcon = null
      for (let i = 0; i < scrollMatchItemHeightArr.length; i++) {
        const item = scrollMatchItemHeightArr[i]
        if (item.heightPx > valPx && valPx <= item.heightPx) {
          if (item.heightPx - this.matchItemPbpx < valPx) {
            curMatchLabelFixedIcon = null
          } else {
            curMatchLabelFixedIcon = item.icon
          }
          break
        }
      }
      console.debug(
        'curMatchLabelFixed:',
        scrollMatchItemHeightArr,
        curMatchLabelFixedIcon,
        valPx,
        direction
      )
      this.curMatchLabelFixedIcon = curMatchLabelFixedIcon
    },
    getScheduleMatchListDomHeigt() {
      let scrollMatchItemHeightArr = []
      let curHeightPx = 0
      const matchList = this.matchList
      matchList.forEach((item) => {
        let dom = document.getElementById(`matchList_${item.icon}`)
        curHeightPx += dom.offsetHeight //里面含paddingBottom值了
        scrollMatchItemHeightArr.push({
          icon: item.icon,
          heightPx: curHeightPx,
        })
      })
      console.debug('getScheduleMatchListDomHeigt:', scrollMatchItemHeightArr)
      this.scrollMatchItemHeightArr = scrollMatchItemHeightArr
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
    },
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      await this.getDelegationDetailPlayerList()
      console.debug(this.stageArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    onResizeEvent() {
      this.initPbPx()
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedMatchList(group) {
      console.debug('computedMatchList:', group)
      let matchLabelArr = this.matchLabelArr
      let matchList = []
      if (group && group.length > 0) {
        matchList = group.map((item) => {
          return {
            label: item.disciplineName,
            icon: item.disciplineCode,
            rigthNum: item.athletes.length,
            list: item.athletes.map((ceil) => {
              return {
                playerId: ceil.athleteCode,
                playerName: ceil.athleteName,
                playerLogo: ceil.athleteLogo,
                gender: ceil.gender,
                birthDate: ceil.birthDate,
                height: ceil.height,
                weight: ceil.weight,
                sportCN: '',
                delegationLogo: '',
                delegationName: '',
              }
            }),
          }
        })
        this.matchList = matchList
        this.matchLabelArr = matchLabelArr
        console.debug('computedMatchList end:', matchList, matchLabelArr)
      } else {
        this.matchList = matchList
      }
    },
    async getDelegationDetailPlayerList() {
      await https_delegationDetail_players(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        delegationId: this.query.delegationId,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.matchTotal = res.data ? res.data.length : 0
              this.computedMatchList(res.data)
              this.initScroll()
            } else {
              console.debug('暂无数据')
            }
            console.debug(
              '暂无数据:',
              this.matchTotal,
              this.matchList,
              this.matchList.length
            )
            if (this.matchTotal === 0) {
              this.matchList = []
            } else {
              this.$nextTick(() => {
                this.loading = false
                this.getScheduleMatchListDomHeigt()
              })
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_delegationDetail_players {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 50%;
            z-index: 2;
            transform: translateY(-50%);
            width: 21.55%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 2.778vw;
              height: 2.778vw;
              border: 1.5px solid var(--mixtmt_whiteColor);
              border-radius: 50%;
              overflow: hidden;
              margin-right: 0.694vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
          .label_rightArea {
            position: absolute;
            right: 0;
            top: 0.347vw;
            z-index: 2;
            width: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--mixtmt_greyColor3);
            .rightArea_name,
            .rightArea_value {
              font-size: 1.11vw;
            }
            .rightArea_value {
              width: 2.5vw;
              text-align: center;
            }
          }
        }
      }
      /* .scrollDomContain {
        max-height: calc(100vh - 19.142vw);
        overflow: auto;
      } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
